import api from './api';

const permissionService = {
  // Get all available permission types
  async getPermissionTypes() {
    const response = await api.get('/permissions/types');
    return response.data;
  },

  // Get current user's permissions
  async getMyPermissions() {
    const response = await api.get('/permissions/my');
    return response.data;
  },

  // Get all users with their permissions (admin only)
  async getAllUsersWithPermissions(page = 1, limit = 10, search = '') {
    const response = await api.get('/permissions/users', {
      params: { page, limit, search }
    });
    return response.data;
  },

  // Get permissions for a specific user
  async getUserPermissions(userId) {
    const response = await api.get(`/permissions/users/${userId}`);
    return response.data;
  },

  // Update permissions for a user
  async updateUserPermissions(userId, permissions) {
    const response = await api.put(`/permissions/users/${userId}`, { permissions });
    return response.data;
  },

  // Check if user has a specific permission (client-side helper)
  hasPermission(userPermissions, permissionKey) {
    if (!userPermissions) return false;
    if (userPermissions.isAdmin) return true;
    return userPermissions.permissions?.includes(permissionKey);
  },

  // Permission keys (should match backend)
  PERMISSIONS: {
    PLAYLIST_EDIT_SINGLE: 'playlist.edit.single',
    PLAYLIST_EDIT_BATCH: 'playlist.edit.batch',
  }
};

export default permissionService;
